import { z } from "zod";
import { DocumentTypeIdSchema } from "../treezor/index.js";

export default {
  params: z.object({
    accountId: z.string(),
    userId: z.number().int(),
    documentTypeId: DocumentTypeIdSchema,
  }),
  response: z.object({
    documentId: z.string(),
    form: z.object({
      action: z.url(),
      method: z.string(),
      enctype: z.string(),
    }),
    formFields: z.looseObject({}),
    expireIn: z.number(),
  }),
};
